import React, { useEffect, useState } from 'react';
import './news.css';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SlickArrow from '../shared/SlickArrow';

import Title from '../shared/Title';
// import Description from '../shared/Description';
import Popup from 'reactjs-popup';

// import newsAPI from '../../api/news';
import { Markup } from 'interweave';

// import loadingIcon from '../../assets/images/loading/loading.gif';
import { apispreadsheets } from '../shared/ApiSpreadSheets';
// import axios from 'axios';


//Slider settings
var settings = {
  dots: false,
  speed: 500,
  slidesToShow: 4,
  lazyLoad: true,
  arrows: true,
  swipe: true,
  autoplay: true,
  autoplaySpeed: 5000,
  nextArrow: <SlickArrow right="-2rem" />,
  prevArrow: <SlickArrow left="-2rem" />,
  responsive: [
    {
      breakpoint: 1248,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 845,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const contentStyle = {
  maxWidth: '1024px',
  width: '90vw',
  height: '95vh',
};

const News = () => {
  const [newsList, setNewsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  //For news detail
  const [modalOpen, setModalOpen] = useState(false);
  const [popupNews, setPopupNews] = useState({});
  // const [isDetailLoading, setIsDetailLoading] = useState(true);

  const [title, setTitle] = useState();
  const [description, setDescription] = useState();

  const [urlApi, setUrlApi] = useState([]);
  const domain = "https://aptechcantho.cusc.vn/";
  // const proxy = "https://api-proxy.phangialac2406.workers.dev/";

  useEffect(() => {
    const sheetName = 'tintuc_sukien';
    // console.log(`${apispreadsheets}/${sheetName}`)
    fetch(`${apispreadsheets}/${sheetName}`)
      .then((res) => res.json())
      .then(
        (results) => {
          setTitle(results[0].tieu_de);
          setDescription(results[0].mo_ta);
          setUrlApi(results.map(row => row.duong_dan.trim()).filter(Boolean));
        },
        (error) => {
          console.log('error: ', error);
          setIsLoading(false);
        },
      );
  }, []);

  useEffect(() => {
    const sheetName = 'tintuc_sukien';
    const fetchData = async () => {
      const batchSize = 4;

      const fetchBatch = async (batch) => {
        try {

          const responses = await Promise.all(
            batch.map((url) =>
              fetch(`${apispreadsheets}/${sheetName}`)
                .then((res) => res.json())
                .then(results => {
                  const rs = results[0].api.split('\n').map(apiUrl => apiUrl.trim());
                  return fetch(`${rs}?target=${encodeURIComponent(url)}`)
                    .then((res) => res.text())
                    .catch((err) => {
                      console.error("Error fetching data:", err);
                      return null;
                    });
                })
            )
          );

          // const ignoreLinks = [
          //   "https://aptechcantho.cusc.vn/?tabid=198&NDID=12868&key=Mo_hinh_giao_duc_rut_gon_giup_nguoi_tre_som_gia_nhap_thi_truong",
          //   "https://arenacantho.cusc.vn/?tabid=359&NDID=12853&key=HOI_THAO_CHON_DUNG_NGANH_%E2%80%93_VUNG_TUONG_LAI_%E2%80%93_DU_HOC_QUOC_TE"
          // ];

          // const filteredData = responses
          // .map((response, index) => ({ response, link: batch[index] }))
          // .filter(item => !ignoreLinks.includes(item.link));

          // console.log(responses);

          const newsData = responses.map((response, index) => {

            // response lỗi → bỏ qua
            if (!response) return null;

            // https://aptechcantho.cusc.vn/?tabid=198&NDID=12868&key=Mo_hinh_giao_duc_rut_gon_giup_nguoi_tre_som_gia_nhap_thi_truong
            
            // https://arenacantho.cusc.vn/?tabid=359&NDID=12853&key=HOI_THAO_CHON_DUNG_NGANH_%E2%80%93_VUNG_TUONG_LAI_%E2%80%93_DU_HOC_QUOC_TE

            const parser = new DOMParser();
            const doc = parser.parseFromString(response, "text/html");

            const titleText = doc.querySelector("table ul .TieuDe")?.innerText || "No Title";
            // không có title → bỏ qua
            if (!titleText) return null;

            const container = doc.querySelector("table");
            if (!container) return null; // không có layout → skip

            const paragraphs = doc.querySelector(".cms_divTomTat");
            const paragraphText = paragraphs?.innerText || "No Content";
            const ogImage = container?.querySelector("tr td img")?.getAttribute("src");

            const detailContent = container?.outerHTML || "<p>No Table Content</p>";
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = detailContent;

            // tempDiv.querySelector(".TieuDe").remove();
            // tempDiv.querySelector(".con-title").remove();
            // tempDiv.querySelector("#right").remove();

            tempDiv.querySelectorAll("div[id*='_divPhanHoiContainer']").forEach((div) => {
              if (div.id.startsWith("dnn_ctr")) {
                div.remove();
              }
            });

            tempDiv.querySelectorAll("div[id*='_divTinKhac']").forEach((div) => {
              if (div.id.startsWith("dnn_ctr")) {
                div.remove();
              }
            });

            tempDiv.querySelectorAll("div").forEach((div) => {
              if (div.innerHTML.trim() === "&nbsp;") {
                div.remove();
              }
            });

            tempDiv.querySelectorAll("img").forEach((img) => {
              const src = img.getAttribute("src");
              if (src && !src.startsWith("http")) {
                img.setAttribute("src", `https://aptechcantho.cusc.vn${src}`);
              }
            });

            return {
              link: batch[index],
              title: titleText,
              image: ogImage ? domain + ogImage : null,
              summary: paragraphText,
              detailContent: tempDiv.innerHTML,
            };
          });

          setNewsList((prevList) => {
            const uniqueNews = newsData.filter(
              (news) => !prevList.some((existingNews) => existingNews.link === news.link)
            );
            return [...prevList, ...uniqueNews];
          });

        } catch (error) {
          console.error("Batch fetching failed:", error);
        }
      };

      const processBatches = async () => {
        for (let i = 0; i < urlApi.length; i += batchSize) {
          const batch = urlApi.slice(i, i + batchSize);
          await fetchBatch(batch);
        }
        setIsLoading(false);
      };

      processBatches();
    };

    fetchData();
  }, [urlApi]);

  //Get News Detail
  const fetchNewsDetail = (link) => {
    const newsDetail = newsList.find((news) => news.link === link);

    if (newsDetail) {
      // setIsDetailLoading(true);
      setPopupNews(newsDetail);
      setModalOpen(true);
    } else {
      console.error("News detail not found for link:", link);
    }
  };

  // useEffect(() => {
  //   //Get News List
  //   const fetchNewsList = async () => {
  //     const res = await newsAPI.getAll();
  //     setNewsList(res);
  //     setIsLoading(false);
  //   };
  //   fetchNewsList().catch(console.error);
  // }, []);
  return (
    <div className=" w-full overflow-hidden mt-20 relative">
      <Title className="text-primary-color text-center my-8 sm:text-3xl font-bold uppercase">{title}</Title>
      <div className="mt-5 text-justify md:text-center font-medium">
        <Markup
          allowAttributes
          content={description}
        />
      </div>
      {/* News slider */}
      {!isLoading && (
        <Slider className="mt-10 w-auto mx-10" {...settings}>
          {newsList.map((news, index) => (
            <div key={index} className="news-wrapper p-4 overflow-hidden relative">
              <div className="rotate-wrapper relative cursor-pointer overflow-hidden w-auto h-[25rem] rounded-3xl mx-auto">
                <div
                  className="news-content pb-4 relative h-full flex flex-col justify-end"
                  onClick={() => fetchNewsDetail(news.link)}
                >
                  <div className="news-img relative h-full w-auto z-[-1]">
                    <img
                      className="h-auto w-full relative aspect-[1.33333] object-cover bottom-0 left-0"
                      src={news.image}
                      alt="News Thumbnail"
                    />
                  </div>
                  <div
                    className="news-text relative w-full px-8 py-2 
                  grid items-start text-[#000] text-base 
                  bg-white bg-opacity-90 h-fit rounded-3xl text-justify font-semibold"
                  >
                    {news.title.trim()}
                  </div>
                  <div className="mx-4 line-clamp-3">{news.summary}</div>
                </div>
              </div>
            </div>
          ))}
        </Slider>

      )}
      <Popup
        contentStyle={contentStyle}
        open={modalOpen}
        closeOnDocumentClick
        onClose={() => setModalOpen(false)}
      >
        <div className="modal bg-white h-full relative shadow-2xl rounded-[25px]">
          {/* Tiêu đề */}
          <div className="p-4 text-sm md:text-lg font-bold uppercase text-center shadow-[0px_0px_12px_rgba(0,0,0,0.1)] rounded-[25px] flex flex-row-reverse">
            <span
              className="close text-4xl hover:scale-[1.1] cursor-pointer text-red-600 float-right -translate-y-1 font-bold right-0 mx-2"
              onClick={() => setModalOpen(false)}
            >
              &times;
            </span>
            <span className="text-center grow">{popupNews.title}</span>
          </div>
          <div className="content h-full pb-8 px-2.5">
            <div className="news-content-style text-base mt-4 mx-5 md:mx-10 overflow-auto no-scrollbar h-[75vh] relative">
              <div
                className="html-content news-content-style"
                dangerouslySetInnerHTML={{ __html: popupNews.detailContent }}
              />
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default News;
